export enum ApiRoute {
  /** 全局配置 */
  Config = '/Site/configH5',
  /** 都语言版本 */
  LangVersion = '/Lang/H5Version',
  /** 获取客服类型 */
  CustomerUrl = '/Publics/getcustermerUrl',
  /** 多语言包 */
  LangPackage = '/Lang/H5LangPackage',
  /** 静态卡列表 */
  VendorCards = '/v5/debitcard/v2/vendorCards',
  /** 静态附属卡 */
  SubVendorCards = '/v5/debitcard/v2/subVendorCards',
  /** 卡权益 */
  VendorCardRight = '/v5/debitcard/v2/vendorCardRights',
  /** 我的卡片列表 */
  MyCards = '/v5/debitcard/v4/myCards',
  /** 我的附属卡片 */
  MySubCards = '/v5/debitcard/v4/subCards',
  /** 用户所有卡的统计数据 */
  MyCardStats = '/v5/debitcard/v2/myCardStats',
  /** 用户附属卡所有卡的统计数据 */
  MySubCardStats = '/v5/debitcard/v2/subCardStats',
  /** 账单列表 */
  UserBill = '/v5/debitcard/v2/userBill',
  /** 账单详情*/
  UserBillInfo = '/v5/debitcard/v2/userBillInfo',

  /** 卡片详情 */
  MyCardInfo = '/v5/debitcard/v2/myCardInfo',
  /** 卡片详情-加密版本 */
  MyCardInfoEncrypt = '/v5/debitcard/v4/getCardInfo',
  /** 更新卡片的持卡人姓名 */
  UpdateCardUserName = '/v5/debitcard/v2/updateCardUserName',
  /** 更新卡备注 */
  UpdateCardName = '/v5/debitcard/v2/updateCardName',
  /** 更新附属卡备注 */
  UpdateSubCardName = '/v5/debitcard/v2/setSubRemark',
  /** 更新卡的单笔消费限额 */
  UpdateMaxSpendAmountSingle = '/v5/debitcard/v2/updateMaxSpendAmountSingle',
  /** 更新卡的每日消费限额 */
  UpdateMaxSpendAmountDay = '/v5/debitcard/v4/updateMaxSpendAmountDay',
  /** 更新卡的每月消费限额 */
  UpdateMaxSpendAmountMonth = '/v5/debitcard/v2/updateMaxSpendAmountDay',
  /** 更新卡的ATM取现单笔限额 */
  UpdateMaxATMAmountSingle = '/v5/debitcard/v4/updateMaxATMAmountSingle',
  /** 更新卡的ATM取现日限额 */
  UpdateMaxATMAmountDay = '/v5/debitcard/v4/updateMaxATMAmountDay',
  /** 更新卡的ATM取现月限额 */
  UpdateMaxATMAmountMonth = '/v5/debitcard/v4/updateMaxATMAmountMonth',
  /** 修改提款码 */
  UpdatePin = '/v5/debitcard/v2/updatePinCode',
  /** 获取更新PIN码的URL */
  GetUpdatePinUrl = '/v5/debitcard/v3/getUpdatePinUrl',
  /** 快递信息 */
  ExpressInfo = '/v5/debitcard/v2/expressInfo',
  /** 币种列表 */
  CoinList = '/Settings/itemList',
  /** 资产 */
  GetAssets = '/V4/UCenter/Assets/getAssets',
  /** 锁卡 */
  LockCard = '/v5/debitcard/v2/lockUserCard',
  /** pinCode重置 */
  PinLock = '/v5/debitcard/v4/resetPinCodeStatus',
  /** 解锁卡 */
  UnlockCard = '/v5/debitcard/v2/unlockUserCard',
  /** 置顶卡片 */
  StickyTop = '/v5/debitcard/v2/stickyTop',
  /** 删除卡片（隐藏卡片） */
  HiddenCard = '/v5/debitcard/v4/hiddenCard',
  /** 显示卡片 */
  ShowCard = `/v5/debitcard/v4/showCard`,
  /** 销卡 */
  CancelCard = '/v5/debitcard/v4/cancelCard',
  /** 静态表数据 */
  GetStaticTableInfoList = '/Settings/getStaticTableInfoList',
  /** 静态表版本信息 */
  GetStaticTableVersion = '/Settings/getStaticTableList',
  /** 获取充值地址列表 */
  GetRechargeAddressList = '/UCenter/Address/getFinanceAddressList',
  /** 修改地址 */
  SaveFinanceAddress = '/UCenter/Address/saveFinanceAddress',
  /** 创建地址 */
  CreateFinanceAddress = '/UCenter/Address/createFinanceAddress',
  /** 删除地址 */
  DeleteFinanceAddress = '/UCenter/Address/delFinanceAddress',

  /** 发送短信验证码 */
  SendMobileCode = '/V3/UCenter/User/monetaryMobileCode',
  /** 发送邮箱验证码 */
  SendEmailCode = '/V3/UCenter/User/monetaryEmailCode',
  /** 虚拟卡 - 提交开通资料 */
  SubmitCardInfo = '/v5/debitcard/v2/submitCardInfo',
  /** 我申请中的卡 */
  MyApplyingCard = '/v5/debitcard/v2/myApplyingCard',
  /** 开卡费用清单*/
  OpenCardFees = '/v5/debitcard/v2/openCardFees',
  /** 支付开卡费用*/
  PaymentOpenCardFee = '/v5/debitcard/v4/paymentOpenCard',
  /** 附属卡 - 支付开卡费用 */
  PaymentOpenSubCardFee = '/v5/debitcard/v2/subCard/paymentOpenCard',
  /** VIP阶梯消费手续费 */
  ListVipTieredFee = '/v5/debitcard/v3/listVipTieredFee',
  /** 消费报告 */
  ConsumptionReport = '/v5/debitcard/v3/getCardConsumerReport',

  /** 账单导出 - 获取导出历史列表 */
  ExportHistoryList = '/exportBill/index',
  /** 账单导出 - 生成账单 */
  GenerateBill = '/exportBill/generateBill',
  /** 账单导出 - 发送账单邮件 */
  ExportBillSendEmail = '/exportBill/sendEmail',
  /** 账单导出 - 获取导出限制 */
  ExportBillLimit = '/exportBill/getExportLimit',
  /** 账单导出 - 下载账单 */
  ExportBillDownload = '/exportBill/download',
  /** 帮助中心文章列表 */
  HelpCenterArticles = '/V4/HelpCenter/articles',
  /** 国家、省/州、城市三级联动下拉数据 */
  CascadeAddress = '/v5/debitcard/v4/cascadeAddress',
  /** 获取卡的 KYC 配置.    cvcId */
  GetKYCConfig = '/v5/debitcard/v3/getKYCConfig',
  /** 提交KYC数据 */
  SubmitKYCData = '/v5/debitcard/v4/submitKYCData',
  /** 提交附属卡KYC数据 */
  SubmitSubKYCData = '/v5/debitcard/v4/subCard/submitKYCData',
  /** 提交快递信息 */
  SubmitAddressInfo = '/v5/debitcard/v2/submitAddressInfo',
  /** 提交附属卡快递信息 */
  SubmitSubAddressInfo = '/v5/debitcard/v2/subCard/submitAddressInfo',
  /** 金融卡 - 开卡顺序 说明， 展示窗口顺序 1 kyc 2 快递信息 3 付款信息 */
  SubmitOrderDescription = '/v5/debitcard/subCard/submitOrderDescription',
  /** 附属卡 - 初始化 */
  InitSubCard = '/v5/debitcard/v4/subCard/init',
  /**物理卡 绑定为 附属卡 */
  SwitchToSubCard = '/v5/debitcard/v4/subCard/bindCard',
  /** 绑定我的信用卡 */
  CreditCardBindByNo = '/v5/debitcard/v4/bindCard',
  /** 附属卡 通过安全码 绑定 */
  CreditCardBindByCode = '/v5/debitcard/subCard/bindSubCard',
  /** 获取附属卡绑定码 */
  GetSafeCode = '/v5/debitcard/v2/getSafeCode',
  /** 获取默认信息 */
  GetDefaultInfo = `/v5/debitcard/v3/defaultInfo`,
  /** 修改账单备注 */
  UpdateBillRemark = `/v5/debitcard/v4/updateBillRemark`,
  /** 删除未成功的卡片 */
  DeleteCard = '/v5/debitcard/v3/deleteCard',
  /** 设置主卡对附属卡的限额 */
  SetParentSetting = '/v5/debitcard/v4/setParentSetting',
  /** 储蓄卡 - 获取充值手续费 */
  RechargeFee = '/v5/debitcard/v2/rechargeFee',
  /** 储蓄卡 - 充值卡片 */
  RechargeCard = '/v5/debitcard/v2/rechargeCard',
  /** 修改卡片绑定的手机号 */
  ChangeMobile = '/v5/debitcard/v3/changeMobile',
}
